import { createAsyncReducer } from '../../standard-actions/';
import {
    IDeletePaymentMethodAction,
    IDeletePaymentMethodSuccessAction,
    IDeletePaymentMethodErrorAction
} from '../actions/delete-payment-methods';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type DeletePaymentMethodAction
    = IDeletePaymentMethodAction
    | IDeletePaymentMethodSuccessAction
    | IDeletePaymentMethodErrorAction;

const init = (state: IBillingState, action: DeletePaymentMethodAction) => ({
    ...state,
    deletePaymentMethod: {
        ...state.deletePaymentMethod,
        status: action.status
    }
});

const success = (state: IBillingState, action: DeletePaymentMethodAction) => {
    const deletedTid = (action as IDeletePaymentMethodSuccessAction).data;
    const deletedPMethods = state.paymentMethods?.data?.paymentMethods?.filter((d) => d.tid !== deletedTid?.data?.paymentMethod?.tid);
    return {
        ...state,
        paymentMethods: {
            ...state.paymentMethods,
            data: {
                ...state.paymentMethods.data,
                paymentMethods: deletedPMethods,
            }
        },
        deletePaymentMethod: {
            status: action.status,
            data: deletedTid?.data
        }
    }
};

const failure = (state: IBillingState, action: DeletePaymentMethodAction) => ({
    ...state,
    deletePaymentMethod: {
        ...initialState.deletePaymentMethod,
        status: action.status,
        error: (action as IDeletePaymentMethodErrorAction).error,
        errorCode: (action as IDeletePaymentMethodErrorAction).errorCode,
        errorSubcode: (action as IDeletePaymentMethodErrorAction).errorSubcode,
    }
});

const notStarted = (state: IBillingState, action: DeletePaymentMethodAction) => ({
    ...state,
    deletePaymentMethod: {
        status: action.status,
        data: null
    }
});

export const deletePaymentMethodReducer = createAsyncReducer(initialState, init, success, failure, notStarted);
